const sliderTabNavigation = {
    init() {
        const elements = document.querySelectorAll('.js-tab-navigation-slider');

        if (!elements.length) return;

        this.sliderTabNavigation = [];
        elements.forEach((element) => {
            const Slider = slider.default;
            const centeredSlides = element.dataset.centered;
            const sliderElement = new Slider(element, {
                grabCursor: true,
                keyboard: true,
                slideToClickedSlide: true,
                navigation: {
                    prevEl: '.js-tab-navigation-slider-prev',
                    nextEl: '.js-tab-navigation-slider-next',
                    disabledClass: 'button--disabled',
                },
                spaceBetween: 10,
                slidesPerView: 'auto',
                centeredSlides: centeredSlides === 'true',
            });
            this.sliderTabNavigation.push(sliderElement);

            const tabButtons = element.querySelectorAll('.js-simple-tab-button');
            tabButtons.forEach((tabButton, index) => {
                if (tabButton.classList.contains('active')) {
                    sliderElement.swiper.activeIndex = index;
                }
            });

            sliderElement.swiper.on('activeIndexChange', () => {
                const itemIndex = sliderElement.swiper.realIndex;
                tabButtons[itemIndex].click();
            });
        });
    },
};

export default sliderTabNavigation;
